// 'orientationchange' is deprecated, but screen.orientation supports only from Safari 16.4 and our supported browsers
// polyfill for https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation/change_event
if (!screen?.orientation) {
    screen.orientation = {
        addEventListener: function (type, listener, options) {
            if (type === 'change') {
                window.addEventListener('orientationchange', listener, options);
            }
        },
        removeEventListener: function (type, listener, options) {
            if (type === 'change') {
                window.removeEventListener('orientationchange', listener, options);
            }
        },
    };
}
